
const IMAGES = {
    laravelPM: require('../img/laravelPM.png'),
    logoAdobe: require('../img/adobe-logo.png'),
    logoArtStation: require('../img/artstation-logo.png'),
    logoUnity: require('../img/unity-logo.png'),
    logoAWC: require('../img/logo.png'),
    logoWP: require('../img/wp-logo.png'),
    logoMarketing: require('../img/skillsDigitalMarketing.png'),
    imageAWC: require('../img/awc.png'),
    iconBriefcase: require('../img/briefcase.png'),
    iconChat: require('../img/chaticon.png'),
    iconMenu: require('../img/menu-icon.png'),
    projComicCrud: require('../img/comiccrud-screenshot.png'),
    projCrewChat: require('../img/crewchat_screenshot_02.png'),
    projFastChange: require('../img/fast-change-screen.png'),
    projINFMCP: require('../img/infmcp-screenshot.png'),
    projLbiSite: require('../img/lickbeans-site.png'),
    projMAAC: require('../img/maac-after.png'),
    projPython: require('../img/python-figure.png'),
    projWeather: require('../img/react-weather-screenshot.png'),
    projSurvival: require('../img/sh-figure.png'),
    projStarTech: require('../img/startech-screenshot.png'),
    projSumo: require('../img/sumoproto.png'),
    projPerformanceReview: require('../img/performance-review-screen.png'),
    proj3dPlatform: require('../img/3dplatformproto.png'),
    projRoguelike: require('../img/roguelike-screenshot.png'),
    projPETAveganStart: require('../img/petaDEveganstart-screen.png'),
    projPETAwissen: require('../img/petaDEwissenschaft.png'),
    projPETA2Dissection: require('../img/peta2dissection-screen.png'),
    projMarketingData: require('../img/draw-insights-from-marketing-data.png'),
    projMarketingContent: require('../img/marketing-your-content.png'),
    projReadyToMarket: require('../img/get-ready-to-market.png'),
    projTheWakeEvent: require('../img/thewakeevent-title.png'),
    projHeadlineBooster: require('../img/headline-booster-screenshot.png'),
}

export default IMAGES